import { gql } from "@apollo/client";

export default gql`
  mutation CreateMergeLinkToken($linkExpiryMins: Int, $categories: [String]) {
    createMergeLinkToken(
      linkExpiryMins: $linkExpiryMins
      categories: $categories
    ) {
      success
      linkToken
      integrationName
      endUserOriginId
      error
    }
  }
`;
